import HomeState from '../State/HomeState'
import Action, { ActionFetchUserLoaded ,ActionProfile,ActionType } from '../Actions/ActionTypes'
import { Reducer } from 'redux'

const actionFetchUserLoading = (oldState: HomeState, action: Action): HomeState => {
    return { ...oldState, loading : true}
}


const actionFetchUserLoaded = (oldState: HomeState, action: Action): HomeState => {
    let user = (action as ActionFetchUserLoaded).user
    return { ...oldState, user : user , loading : false}
}

const actionProfile = (oldState: HomeState, action: Action): HomeState => {
    return { ...oldState, profile : (action as ActionProfile).open}
}

type Process = (oldState: HomeState, action: Action) => HomeState

export const HomeReducer: Reducer<HomeState, Action> = (state: HomeState = { loading: false, user: undefined,profile : false }, action: Action): HomeState => {

    let actionMap = new Map<ActionType, Process>()

    actionMap.set(ActionType.USER_LOADING, actionFetchUserLoading)
    actionMap.set(ActionType.USER_LOADED, actionFetchUserLoaded)
    actionMap.set(ActionType.SHOW_USER_PROFILE, actionProfile)

    return actionMap.get(action.type)?.call(undefined, state, action) ?? state

}


